import type { SupplierQualificationStatus } from '@/api/client'
import { cn } from '@/lib/cn'
import { useTranslation } from 'react-i18next'

interface Props {
  status: SupplierQualificationStatus
  className?: string
}

export function SupplierStatusBadge({ status, className }: Props) {
  const { t } = useTranslation('suppliers')
  const styles: Record<SupplierQualificationStatus, string> = {
    in_qualification: 'bg-muted text-muted-foreground',
    qualified: 'bg-primary text-primary-foreground',
    suspended: 'bg-muted text-foreground',
    blacklisted: 'bg-muted text-muted-foreground line-through',
  }
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        styles[status],
        className,
      )}
    >
      {t(`qualification.${status}`, { defaultValue: status })}
    </span>
  )
}
